import { ModelBase } from 'store/model-base';

export class NowMobileLandingCollection extends ModelBase {
    public static storeName: string = 'nowMobileLandingCollection';

    public header: NowHeader;
    public lineSummary: NowMobileLandingLineSummary;
    public lines: NowLine[];
    public customerRelationshipId: string;
    public addLine?: NowAddLine;
    public xfinityAssistant: NowXfinityAssistant;
    public nmToXMUpgradeEntryPoint: NowNMToXMUpgradeEntryPoint;

    public static create<T extends ModelBase>(initData: object): T {
        const mobileLandingData: NowMobileLandingCollection = super.create<NowMobileLandingCollection>(initData);
        
        return super.create<T>(mobileLandingData);    
    }
}

